import Vue from 'vue'
import VueRouter from 'vue-router'
import { removeToken } from '../utils/token';

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: '/',
            component: () => import('../components/index.vue'),
            redirect:"/home",
            children: [
                {
                    path:'home',
                    component: () => import('../components/officialWebsite/home/home.vue') //首页
                },
                {
                    path:'association',
                    component: () => import('../components/officialWebsite/association/association.vue') //关于协会
                },
                {
                    path:'recentNews',
                    component: () => import('../components/officialWebsite/recentNews/recentNews.vue') //最新动态
                },
                {
                    path:'policy',
                    component: () => import('../components/officialWebsite/policy/policy.vue') //政策法规
                },
                {
                    path:'case',
                    component: () => import('../components/officialWebsite/case/case.vue') //案例展示
                },
                {
                    path:'member',
                    component: () => import('../components/officialWebsite/member/member.vue') //会员机构名录
                },
                {
                    path:'academic',
                    component: () => import('../components/officialWebsite/academic/academic.vue') //学术交流
                },
                {
                    path:'contactUs',
                    component: () => import('../components/officialWebsite/contactUs/contactUs.vue') //联系我们
                },
                {
                    path:'particulars',
                    component: () => import('../components/officialWebsite/particulars/particulars.vue') // 详情页
                },
            ]
        },
        {
            path: '/login',
            component: () => import('../components/system/login/login.vue')
        },
        // {
        //     path: '*',
        //     component: () => import('../components/common/notFound.vue')
        // },
        {
            path: '/index',
            component: () => import('../components/system/index/index.vue'),
            redirect:"/index/home",
            children: [
                {
                    path:'home',
                    component: () => import('../components/system/home/home.vue') //首页
                },
                {
                    path:'member',
                    component: () => import('../components/system/member/member.vue') //会员列表
                },
                {
                    path:'personal',
                    component: () => import('../components/system/personal/personal.vue') //个人中心
                },
                {
                    path:'revamp',
                    component: () => import('../components/system/revamp/revamp.vue') //个人中心
                },
                {
                    path:'train',
                    component: () => import('../components/system/train/train.vue') //培训
                },
            ]
        },
    ]
})

router.beforeEach((to, from, next) => {
    if (to.path == '/login') {
        removeToken('token');
        window.localStorage.removeItem('user');
        // next();
    }
    next();
})

// 后置守卫
router.afterEach((to) => {
    switch (to.path) {
        case "/home":
            sessionStorage.setItem('tabIndex', 0);
            break;
        case "/association":
            sessionStorage.setItem('tabIndex', 1);
            break;
        case "/recentNews":
            sessionStorage.setItem('tabIndex', 2);
            break;
        case "/policy":
            sessionStorage.setItem('tabIndex', 3);
            break;
        case "/case":
            sessionStorage.setItem('tabIndex', 4);
            break;
        case "/member":
            sessionStorage.setItem('tabIndex', 5);
            break;
        case "/academic":
            sessionStorage.setItem('tabIndex', 6);
            break;
        case "/contactUs":
            sessionStorage.setItem('tabIndex', 7);
            break;
        case "/index/home":
            sessionStorage.setItem('tabNum', 0);
            break;
        case "/index/member":
            sessionStorage.setItem('tabNum', 1);
            break;
        case "/index/personal":
            sessionStorage.setItem('tabNum', 2);
            break;
        case "/index/revamp":
            sessionStorage.setItem('tabNum', 3);
            break;
    
        default:
            break;
    }
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
})
export default router